import { Component,Input,OnInit,HostListener,ViewChild,ElementRef,ViewContainerRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { commonService } from '../../service/common.service';
import { pgService } from '../../service/pg.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import {ActivatedRoute} from "@angular/router";
import {Globals } from '../../globals';
import {NgbCarouselConfig,NgbModal,NgbModalRef,ModalDismissReasons, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { userService } from '../../service/user.service';
import { } from '@types/googlemaps';
import {NgbTabChangeEvent,NgbTabset,NgbTabsetConfig} from '@ng-bootstrap/ng-bootstrap';

import { jobService } from '../../service/job.service';

import { Title,Meta } from "@angular/platform-browser";

@Component({
  selector: 'app-vpgdetail',
  templateUrl: './vpgdetail.component.html',
  styleUrls: ['./vpgdetail.component.css'],
  providers:[Title,Meta,Globals,pgService,NgbCarouselConfig,userService,NgbTabsetConfig,NgbTabset,jobService]
})
export class VpgdetailComponent implements OnInit {
  private tabSet: NgbTabset;
  @ViewChild('gmap') gmapElement: any;
  @ViewChild('t') tElement: any;
  @ViewChild('map') mapElement: any;

  bootRate = 1;
  faRate = 1;
  cssRate = 1;
  faoRate = 3.6;
  faoRated = false;

  onFaoRate(e) {
    this.faoRated = true;
    this.faoRate = e;
  }

  faoReset() {
    this.faoRated = false;
    this.faoRate = 3.6;
  }



  
  editpgId:any;
  getimagesArry:any;
  pgrulesArry: Array<any> = [];
  pgamenitiesArry: Array<any> = [];
  getidArry:Array<any> = [];
  newimageidArry=[];
  showimagearray=[];
  rulesimagearray=[];
  basicinfo:any;
  imagesAry:Array<any> = [];
  userdetailarry:any;
  public locationInput: string = '';
public lat: string = '';
public lng: string = '';
msg:any;
  isSuccess=false;
  isError=false;
  rulesbox:any;
  amenitiesbox:any;
  closeResult: string;
  latA:number;
  longA:number;
  latB:number;
  longB:number;
  showbarInfo:any;


  userlist:any;
  isErrorExcel=false;
  isSuccessExcel=false;
  totalrow:number;
  totalrating:number=0;
  searchtxt:string;
  typetxt:string;
  notfound=false;
  pageSize = 10;
  currentPage = 0;
  start=0;
  end=10; 
  user:any;
  pageEvent: any;
  reviewform:any;
  msgclass:any="";
  userData:any;
  PG='PG/Hostel';

  modalReference:NgbModalRef;
  msgpopup="";
  centerlist:any=[];
  activeTab:any;
  verifyOtpId:any;
  verifyStatus=false;
  mobilevailidation=false;
  ownerarry:any;
  pgownerveifymsg:any;
  

  constructor(private modalService: NgbModal,private _user:userService,config: NgbCarouselConfig,private router:Router,private route: ActivatedRoute,private commonservice:commonService,private global: Globals,private _pg:pgService,private job:jobService,private titleService: Title,private meta: Meta) { 
    this.reviewform={
      'Comment':'',
      'rating':'',
    }
    this.ownerarry={
      'studmobile':'',
      'otp':'',
    }
        this.commonservice.profile.subscribe((data:any)=>{
          //console.log(data);
          if(data){
          this.userData=data; 
          }else{
            this.userData={};
          } 

        });
   }
  path=this.global.pgUrl;
  ngOnInit() {
    this.getpgamenities();
    this.getpghostelrules();

          this.route.queryParams.subscribe(params => { 
            if(params['searchparam']){
              let searchArry:any;
              let resultpar={}
              searchArry=decodeURIComponent(atob(params['searchparam'])).split('&').forEach(function(part,index) {
                 var item = part.split('=');
                 resultpar[index] = item;
              });
             // console.log(resultpar);
              this.editpgId = resultpar[0][1];
              this.latA=parseFloat(resultpar[1][1]);
              this.longA=parseFloat(resultpar[2][1]);
              
              
              this._pg.editpgdetails(this.editpgId).subscribe((data : any)=>{
                if(data.error==0){
                 // console.log('PGHHH');
                 // console.log(data.results);
                  this.showbarInfo={
                    'sbhk':resultpar[3][1],
                    'sadd':resultpar[4][1],
                    'scity':resultpar[5][1],
                  };

                  
                  
                  var availableServices=data.results.availableServices.split(',');
                  this.pgrulesArry=data.results.pgHostelRules.split(',').map(Number);
                  this.pgamenitiesArry=data.results.pgamenities.split(',').map(Number);
                  
                  if(data.results.pgPropertyGallery!=null){
                  this.getimagesArry=data.results.pgPropertyGallery.images.split(',');
                  this.getidArry=data.results.pgPropertyGallery.id.split(',');
                  
                  for (var i = 0; i < this.getimagesArry.length; i++ ){
                    this.newimageidArry.push({id:this.getidArry[i],image:this.getimagesArry[i]});
                  }
                 }

                 if(this.showimagearray.length>0){
                  let imagesdetails: any[] = [];
                  this.showimagearray.forEach((item, index) => {
                    if (this.pgamenitiesArry.includes(item.id)) {
                        imagesdetails.push(item);
                      }
                   });
                  this.amenitiesbox=imagesdetails;
                 }

                 if(this.rulesimagearray.length>0){
                  let ruleimagesdetails: any[] = [];
                  this.rulesimagearray.forEach((item, index) => {
                    if (this.pgrulesArry.includes(item.id)) {
                      ruleimagesdetails.push(item);
                      }
                  });
                  this.rulesbox=ruleimagesdetails;
                 }


                 this.basicinfo=data.results;
                  //console.log(this.basicinfo);
                  /*******Get user details*****/
                  // this._user.editgetuser(data.results.userId).subscribe((datauser : any)=>{
                  //   if(datauser.error==0){
                  //     //console.log(datauser.results);
                  //     this.userdetailarry=datauser.results;
                  //     console.log(this.userdetailarry);
                  //    }else{
                  //     if(data.message=="Failed to authenticate token."){
                  //       this.router.navigate(['/admin']);
                  //     }else{
                  //     this.msg = data.message;
                  //     this.isError = true;
                  //     }
                  //   }
          
                  // });

                  /*******Get user details*****/

                  if(data.results.pgPropertyGallery!=null){
                  this.imagesAry=data.results.pgPropertyGallery.images.split(',');
                  }
                  else{
                    this.imagesAry=["noimg.jpg"];
                  }
                  this.locationInput=data.results.locality;
                  this.lat=data.results.latitude;
                  this.lng=data.results.longitude;
                  this.latB=parseFloat(data.results.latitude)
                  this.longB=parseFloat(data.results.longitude);
                  this._pg.centerdetails(this.latB,this.longB).subscribe((datacenter : any)=>{
                    if(datacenter.error==0){
                      //console.log(datacenter.results); 
                      this.centerlist=datacenter.results;
                      //console.log(this.centerlist[0]);
                      
                    }
                    if(!isNaN(this.latA) && !isNaN(this.longA)){
                      this.initMap();
                    }
                    
                   
                  });

                  
                  this.getreviewerlist();
                  this.setmetatitledes(data.results.locality,data.results.locality);
                }
              })
            }
          });
          
   }

   setmetatitledes(title,des){
    this.titleService.setTitle(title+' - MADEEASY');
    this.meta.addTag({ name: 'description', content: des });
  }

   public beforeChange($event: NgbTabChangeEvent) {
     
    //console.log('pppp');
    if ($event.nextId === 'tab-preventchange2') {
      $event.preventDefault();
      //console.log('testtab');
    }
  };

  onTabSelect(data: NgbTabChangeEvent) {
    //console.log('ooo');
    if (data.hasOwnProperty('nextId')) { 
                //console.log('testtab');
            }   
    }
   ngAfterViewInit() {
  }
   

   initMap() {
    var markers = [];
    var pointA = new google.maps.LatLng(this.latA,this.longA),
        pointB = new google.maps.LatLng(this.latB, this.longB);
        // for(var i in this.centerlist){
        //   var pointi = new google.maps.LatLng(this.centerlist[i].latitude, this.centerlist[i].longitude);
          
        //  }
      var myOptions = {
            zoom: 0,
            //center: pointA,
            // mapTypeId: google.maps.MapTypeId.ROADMAP,
            // mapTypeControl: false,
            // mapTypeControlOptions: {
            //     style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR
            // },
            // navigationControl: true,
            // navigationControlOptions: {
            //     style: google.maps.KmlLayerStatus
            // }
        },
        map = new google.maps.Map(this.gmapElement.nativeElement, myOptions),
        // Instantiate a directions service.
        directionsService = new google.maps.DirectionsService,
        directionsDisplay = new google.maps.DirectionsRenderer({
            map: map
        }),
       markerA = new google.maps.Marker({
            position: pointA,
            title: "Origin",
            label: "",
            map: map
        }),
        markerB = new google.maps.Marker({
            position: pointB,
            title: "PG",
            label: "",
            map: map
        });
        if(this.centerlist.length>0){
        for(var i in this.centerlist){
          var markeri = new google.maps.Marker({
            position: new google.maps.LatLng(this.centerlist[i].latitude, this.centerlist[i].longitude),
            title: this.centerlist[i].centerAddress,
            label: "",
            map: map
           });
           map.setCenter(new google.maps.LatLng(this.centerlist[0].latitude, this.centerlist[0].longitude)); 

           markers.push(markeri);
           
        }
       }
       markers.push(markerA);
       markers.push(markerB);
       var bounds = new google.maps.LatLngBounds();
        //console.log(markers);
        for (var j = 0; j < markers.length; j++) {
          bounds.extend(markers[i].getPosition());
         }
         
         map.fitBounds(bounds);
        ;
          

        

    // get route from A to B
    this.calculateAndDisplayRoute(directionsService, directionsDisplay, pointA, pointB);
    //this.calculateAndDisplayRoute(directionsService, directionsDisplay, pointA, pointC);

}





 calculateAndDisplayRoute(directionsService, directionsDisplay, pointA, pointB) {
    directionsService.route({
        origin: pointA,
        destination: pointB,
        avoidTolls: true,
        avoidHighways: false,
        optimizeWaypoints: true,

        travelMode: google.maps.TravelMode.DRIVING
    }, function (response, status) {
        if (status == google.maps.DirectionsStatus.OK) {
            directionsDisplay.setDirections(response);
        } else {
            window.alert('Directions request failed due to ' + status);
        }
    });
}

   getpghostelrules(){
    this._pg.pgrules('').subscribe((data : any)=>{
            if(data.error==0){ 
              //console.log(data.results);
              this.rulesbox = data.results;
              this.rulesimagearray=  data.results; 
            }else{
              if(data.message=="Failed to authenticate token."){
                this.router.navigate(['/admin']);
              }else{
               this.msg = data.message;
               this.isError = true;
              }
            }
     },
       (error : HttpErrorResponse)=>{
         this.isError = true;
         this.msg="internal server error!";
       });
  
  }


  getpgamenities(){
    this._pg.pgamenities('').subscribe((data : any)=>{
            if(data.error==0){
              this.amenitiesbox = data.results;   
              this.showimagearray=data.results;
            }else{
              if(data.message=="Failed to authenticate token."){
                this.router.navigate(['/admin']);
              }else{
               this.msg = data.message;
               this.isError = true;
              }
            }
     },
       (error : HttpErrorResponse)=>{
         this.isError = true;
         this.msg="internal server error!";
       });
  
  }
  open2(content) { 
    this.modalService.open(content).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    });
  }


  

    getreviewerlist(){
      var ReviewType = 'PG';
      this.job.getrecruiterReviewlistFront({0:this.start,1:this.end,2:this.searchtxt,3:this.basicinfo.userId,4:ReviewType}).subscribe((data : any)=>{
  
              if(data.error==0){ 
                  this.userlist = data.results.rows;
                 // console.log(this.userlist);
                  this.totalrow = data.results.count;
                  if(data.results.rows.length>0){
                    var rating=data.results.rows[0].totalrating;
                    var ratingcalper=rating/this.totalrow;
                    this.totalrating= Math.round(ratingcalper);
                  }
                  
                  
  
                if(this.totalrow==0){
                  this.notfound=true;
                }else{
                  this.notfound=false;
                }
                
              }else{
                if(data.message=="Failed to authenticate token."){
                  this.router.navigate(['/admin']);
                }else{
                 this.msg = data.message;
                 this.isError = true;
                }
              }
       },
         (error : HttpErrorResponse)=>{
           this.isError = true;
           this.msg="internal server error!";
         });
    
   }

   registerrating(ratingform){
    let ratingDetails:any={};
    if(this.userData){
     // console.log(this.userData);
      ratingDetails.rating=ratingform.value.Rating;
      ratingDetails.jobId=this.basicinfo.id;
      ratingDetails.comment=ratingform.value.comment;
      ratingDetails.userId=this.basicinfo.userId;
      ratingDetails.studentId=this.userData.id;
      ratingDetails.status='Inactive';
      ratingDetails.type='PG';
   // console.log(ratingDetails);
    this.job.addjobrating(ratingDetails).subscribe((data : any)=>{
      if(data.error==0){ 
        this.msgclass="success";
        this.msgpopup="Review added successfully";
        this.getreviewerlist();
        this.reviewform={
          'Comment':'',
          'rating':'',
        }
      }
    });

    }
    
  }

   open(content) {
    if(Object.keys(this.userData).length == 0){
      this.needLogin();
      return false;
    } 

    this.msgpopup="";
    this.modalReference =  this.modalService.open(content,{ }); 
   /* this.modalReference= this.modalService.open(content,{size:"lg"}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });*/
}
  needLogin(){
    this.commonservice.setLoginBox(true);        
  }

  ownerVerification(verifyform){
    if(verifyform.status=="INVALID"){
      this.mobilevailidation=true;
      this.msgclass="danger";
      this.pgownerveifymsg="Please fill all the details";
     }else{
      this.mobilevailidation=false;
      verifyform.value.type='PG';
   // console.log(verifyform.value);
    //console.log(this.verifyOtpId);
    if(this.verifyOtpId){
      //console.log('id find');
      
      this._pg.verifyOTP(verifyform.value,this.verifyOtpId).subscribe((dataverify : any)=>{
        //console.log('MSG Responcettt');
        //console.log(dataverify);
        if(dataverify.error==0){ 
          this.verifyOtpId='';
          this.verifyStatus=false;
          this.mobilevailidation=true;
          this.msgclass="success";
          this.ownerarry={
            'studmobile':'',
            'otp':'',
          }
          this.pgownerveifymsg="Detail has been send on your mobile.";
        }
        else{
          this.mobilevailidation=true;
           this.msgclass="danger";
           this.pgownerveifymsg=dataverify.message;
          
        }
      });
    }
    else{
      this._pg.sendOTP(verifyform.value).subscribe((data : any)=>{
       // console.log('MSG Responce1234');
       // console.log(data);
        if(data.error==0){ 
          this.verifyOtpId=data.lastinserId;
          this.verifyStatus=true;
          
          
        }
      });
  
    }
   }
    
  }

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/vpgdetail/vpgdetail.component.ts